import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { DatePickerComponent } from './date-picker.component';
import { SelectGridModule } from '../select-grid/select-grid.module';
import { FormsModule } from '@angular/forms';
import { DirectivesModule } from '../../directives/directives.module';
import { DropdownModule } from '../dropdown/dropdown.module';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [DatePickerComponent],
  exports: [DatePickerComponent],
  entryComponents: [DatePickerComponent],
  imports: [
    CommonModule,
    FormsModule,
    TranslateModule,
    AngularSvgIconModule,
    SelectGridModule,
    DirectivesModule,
    DropdownModule
  ]
})
export class DatePickerModule {}

export { DatePickerComponent };
